import axios from "axios";
import store from "./../state/store";
import {
  isPreLaunchBlocked,
  preLaunchBlockedMessage
} from "./../utils/apiErrors";
import { withClinicHeader } from "./clinicHeader";

let AXIOS;

if (process.env.NODE_ENV === "test") {
  // Em testes: aponta para o Rails de development. nock intercepta as chamadas
  // antes de chegarem na rede — sem cassette gravado, o teste falha (lockdown).
  // Para gravar um cassette novo: VCR_MODE=record npm run test:unit
  AXIOS = axios.create({
    baseURL: `${process.env.VUE_APP_API_BASE_PATH}/api/v1/`,
    timeout: 30000,
    adapter: require("axios/lib/adapters/http")
  });
} else {
  AXIOS = axios.create({
    baseURL: `${process.env.VUE_APP_API_BASE_PATH}/api/v1/`,
    timeout: 30000
  });

  AXIOS.interceptors.request.use(config =>
    withClinicHeader(config, store.state)
  );

  AXIOS.interceptors.request.use(
    config => {
      let headers = JSON.parse(
        window.sessionStorage.getItem("headers") || null
      );
      if (headers && headers["access-token"]) {
        config.headers.common["access-token"] = headers["access-token"];
        config.headers.common["client"] = headers["client"];
        config.headers.common["uid"] = headers["uid"];
        config.headers.common["expiry"] = headers["expiry"];
        config.headers.common["token-type"] = headers["token-type"];
      }
      return config;
    },
    error => Promise.reject(error)
  );

  AXIOS.interceptors.response.use(
    function(response) {
      if (response.headers["client"]) saveHeaders("headers", response);
      return response;
    },
    function(error) {
      if (isPreLaunchBlocked(error)) {
        handle_pre_launch_blocked(error);
        return Promise.reject(error);
      }
      if (unauthorized_user(error)) {
        swal
          .fire({
            title: "Sessão expirada",
            text: "Sua sessão expirou. Por favor faça login novamente!",
            icon: "info",
            confirmButtonText: "OK",
            closeOnConfirm: false
          })
          .then(() => {
            store.dispatch("auth/logout");
          });
      }
      return Promise.reject(error);
    }
  );
}

function saveHeaders(key, response) {
  let headers = {};
  headers["access-token"] = response.headers["access-token"];
  headers["client"] = response.headers["client"];
  headers["uid"] = response.headers["uid"];
  headers["expiry"] = response.headers["expiry"];
  headers["token-type"] = "Bearer";
  window.sessionStorage.setItem(key, JSON.stringify(headers));
}

const unauthorized_user = error =>
  error.response.status === 401 &&
  !error.response.config.url.includes("auth/sign_in");

// Barreira do Modo Pré-Lançamento, em dois casos: o gestor ligou o modo com a
// aplicação já carregada, e o login recusado de quem está fora do snapshot.
// Como o backend responde 401, este teste precisa vir ANTES de
// `unauthorized_user` — senão a barreira viraria "sessão expirada".
function handle_pre_launch_blocked(error) {
  store.dispatch("preLaunch/markBlocked", preLaunchBlockedMessage(error));

  // `require` tardio de propósito: importar o router no topo deste módulo faria
  // `Vue.use(VueRouter)` rodar em qualquer suíte que só precisa de um service,
  // quebrando os testes que injetam `$route` via mocks.
  const router = require("./../router").default;

  if (router.currentRoute.name !== "PreLaunch") {
    router.push({ name: "PreLaunch" }).catch(() => {});
  }
}

export default AXIOS;
